import { ICasoAtividade } from "../../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import UnForm from "../../../../Form";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { CadastrarCasoAtividadeController } from "../../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useForm } from "react-hook-form";
import { SetStateAction, useState } from "react";
import { listarTipoAtividadesController } from "../../../../../Controllers/Geral/TipoAtividades";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";

interface ICasoAtividadeProps {
    setShow: (value: SetStateAction<boolean>) => void;
}

export default function CasoAtividade(props: ICasoAtividadeProps) {
    const [flagConcluido, setFlagConcluido] = useState(false);

    const FormMethods = useForm();
    const { ID_CASO, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { value: lstTipoAtividades } = useAsyncEffect(
        listarTipoAtividadesController
    );
    const [idTipoAtividade, setSelectedOption] = useState<number>(
        lstTipoAtividades?.[0]?.ID_TIPO_ATIVIDADE ?? 0
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(Number(event.target.value));
    };

    const {
        execute: cadastrarCasoAtividade,
        loading: cadastrarCasoAtividadeLoading,
    } = useAsyncCallback(CadastrarCasoAtividadeController);

    function CadastrarCasoAtividadeSubmit(formData: ICasoAtividade) {
        cadastrarCasoAtividade({
            DT_CASO_ATIVIDADE: formData.DT_CASO_ATIVIDADE,
            DT_CONCLUSAO: formData.DT_CONCLUSAO,
            DT_DURACAO: formData.DT_DURACAO,
            FL_CONCLUIDO: flagConcluido,
            ID_CASO: ID_CASO,
            ID_CASO_ATIVIDADE: formData.ID_CASO_ATIVIDADE,
            ID_TIPO_ATIVIDADE: idTipoAtividade ?? 0,
            ID_USUARIO_CADASTRADO: formData.ID_USUARIO_CADASTRADO,
            ID_USUARIO_RESPONSAVEL: Atendimento?.ID_USUARIO_RESPONSAVEL ?? 0,
            VL_CUSTO: formData.VL_CUSTO,
            DS_HISTORICO: formData.DS_HISTORICO,
        }).then(() => {
            props.setShow(false);
            ReloadHistorico();
        });
    }

    return (
        <div>
            <UnForm
                handleSubmit={CadastrarCasoAtividadeSubmit}
                className="mb-4"
            >
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-center align-items-center flex-column">
                        <h6>Tipo Atividade</h6>
                        <div className="d-flex justify-content-center align-items-center flex-wrap">
                            {lstTipoAtividades?.map((lst) => (
                                <div
                                    className="form-group d-flex flex-column justify-content-center align-items-center px-3"
                                    style={{ minWidth: "120px" }}
                                    key={lst.ID_TIPO_ATIVIDADE}
                                >
                                    <UnForm.Input
                                        type="radio"
                                        name="ID_TIPO_ATIVIDADE"
                                        value={lst.ID_TIPO_ATIVIDADE}
                                        checked={
                                            idTipoAtividade ===
                                            lst.ID_TIPO_ATIVIDADE
                                        }
                                        onChange={handleChange}
                                        required
                                    />
                                    <i
                                        className={`${lst.DS_ICONE} text-dark pl-2 pr-3`}
                                    />
                                    <span>{lst.DS_TIPO_ATIVIDADE}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Data</label>
                            <UnForm.Input
                                type="date"
                                name="DT_CASO_ATIVIDADE"
                                className="form-control"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Duração</label>
                            <UnForm.Input type="time" name="DT_DURACAO" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="d-flex align-items-center justify-content-center">
                            <span>Conclusão</span>
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                            data-toggle="tooltip"
                        >
                            <label className="pt-3">
                                <input
                                    name="FL_CONCLUIDO"
                                    type="checkbox"
                                    ref={FormMethods.register()}
                                    checked={flagConcluido}
                                    onChange={(e) =>
                                        setFlagConcluido(e.target.checked)
                                    }
                                />

                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <label>Comentário</label>
                            <UnForm.Textarea
                                name="DS_HISTORICO"
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <UnForm.SubmitButton
                        color="success"
                        wrapperClassName="w-100 mt-8"
                        className="w-100"
                        icon={faPlus}
                        loading={cadastrarCasoAtividadeLoading}
                        disabled={cadastrarCasoAtividadeLoading}
                        loadingSize={"sm"}
                    >
                        Cadastrar Atividade
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </div>
    );
}
